import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { IServerUserInfo } from '../../../../ts/models/IServerUserInfo';
import { ServerService } from '../../../../ts/services/ServerService';
import { serverUserResetLoginRateLimiting } from '../../../actions/spaces/ServerUserMenuActions';
import { ServiceLocator } from '../../../ServiceLocator';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { isSingleSelectServerUserGuest } from './IEntityActionHelpers';

export const ServerUserResetLoginRateLimitingAction: IEntityAction<IServerUserInfo, {}> = {
  name: EntityActionNames.ServerUserResetLoginRateLimiting,
  translateName: Messages.resetLoginRateLimiting_action,
  isVisible: (_targetItems: IServerUserInfo[], _state: AppState) => {
    const serverService = ServiceLocator.get<ServerService>('ServerService');
    return FeatureFlags.localAuthLoginRateLimitingEnabled && serverService.isServerDomainFamilyLocal();
  },
  isClickable: (_availableActions: {}, targetItems: IServerUserInfo[], _state: AppState) => {
    return targetItems.length > 0 && !isSingleSelectServerUserGuest(targetItems);
  },
  createReduxAction: (targetItems: IServerUserInfo[]) => serverUserResetLoginRateLimiting(targetItems)
};
